import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/images/close.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-5c852cc1"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "inner"
};
var _hoisted_2 = {
  "class": "questionnaire"
};
var _hoisted_3 = {
  "class": "subtitle"
};
var _hoisted_4 = {
  key: 0,
  "class": "title"
};
import { close, getUrlParams } from '@/utils/tools';
import { computed, ref } from 'vue';
import { t } from '@/lang';
import { useRoute } from 'vue-router';
import { MemoryStorage } from '@/utils/MemoryStorage';
import { getCountry } from '@/locales';
import { useAnimationBox } from '@/hooks/useAnimationBox';
import { onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'DWelcome',
  props: {
    min: {
      "default": 1000000
    },
    max: {
      "default": 1000000
    }
  },
  setup: function setup(__props) {
    var _getUrlParams, _getUrlParams2;
    var _useAnimationBox = useAnimationBox(),
      canvasRef = _useAnimationBox.canvasRef,
      wrapRef = _useAnimationBox.wrapRef,
      initBox = _useAnimationBox.init,
      onComplete = _useAnimationBox.onComplete;
    var CurrencyUnitMap = {
      "in": 'INR',
      'zh-cn': '¥',
      vi: '₫',
      my: '',
      mm: '',
      th: '฿',
      us: '$'
    };
    var getCurrencyUnit = function getCurrencyUnit() {
      var _CurrencyUnitMap$coun;
      var country = getCountry();
      if (country === 'my' || country === 'mm') return '';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return (_CurrencyUnitMap$coun = CurrencyUnitMap[country]) !== null && _CurrencyUnitMap$coun !== void 0 ? _CurrencyUnitMap$coun : '$';
    };
    var props = __props;
    var textShow = ref(false);
    var awardText = computed(function () {
      if (props.min === undefined || props.max === undefined) {
        return '';
      }
      var min = props.min / 1000;
      var max = props.max / 1000;
      if (min === max) {
        return "+".concat(getCurrencyUnit()).concat(min);
      }
      if (min === 0) {
        return "+".concat(getCurrencyUnit()).concat(max);
      }
      return "+".concat(getCurrencyUnit()).concat(min, " ~ +").concat(getCurrencyUnit()).concat(max);
    });
    var visible = ref(false);
    var route = useRoute();
    var title = computed(function () {
      return t().A1();
    });
    var subtitle = computed(function () {
      return t().A26();
    });
    var start = computed(function () {
      return t().A27();
    });
    var userId = ((_getUrlParams = getUrlParams()) === null || _getUrlParams === void 0 ? void 0 : _getUrlParams.userid) || ((_getUrlParams2 = getUrlParams()) === null || _getUrlParams2 === void 0 ? void 0 : _getUrlParams2.user_id);
    var onStart = function onStart() {
      var act_id = route.params.id;
      var storage = MemoryStorage.getInstance();
      var key = "survey_".concat(act_id, "_").concat(userId, "_welcome");
      storage.setItem(key, '1');
      visible.value = false;
    };
    var init = function init() {
      var storage = MemoryStorage.getInstance();
      var act_id = route.params.id;
      var key = "survey_".concat(act_id, "_").concat(userId, "_welcome");
      var hasWelcome = storage.getItem(key);
      if (!hasWelcome) {
        visible.value = true;
        initBox();
        onComplete(function () {
          textShow.value = true;
        });
      }
    };
    onMounted(function () {
      init();
    });
    return function (_ctx, _cache) {
      var _component_d_button = _resolveComponent("d-button");
      return _openBlock(), _createElementBlock("div", {
        "class": "welcome",
        style: _normalizeStyle({
          zIndex: visible.value ? 100 : -1
        })
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        "class": "close",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
        //@ts-ignore
        function () {
          return _unref(close) && _unref(close).apply(void 0, arguments);
        }, ["stop"]))
      }), _createElementVNode("h3", _hoisted_2, _toDisplayString(title.value), 1), _createElementVNode("h4", _hoisted_3, _toDisplayString(subtitle.value), 1), _createElementVNode("div", {
        ref_key: "wrapRef",
        ref: wrapRef,
        "class": "award"
      }, [_createElementVNode("canvas", {
        ref_key: "canvasRef",
        ref: canvasRef,
        "class": "award-canvas"
      }, null, 512), awardText.value && textShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(awardText.value), 1)) : _createCommentVNode("", true)], 512), _createVNode(_component_d_button, {
        "class": "start-btn",
        onClick: onStart
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(start.value), 1)];
        }),
        _: 1
      })])], 4);
    };
  }
});